// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wy-0";
export var confirmationIcon = "_wy-1";